'use client';

/**
 * Audio Interview Provider Configuration
 *
 * This config determines which audio interview provider is used.
 * Toggle between 'livekit' and 'elevenlabs' implementations.
 */

export type AudioInterviewProvider = 'livekit' | 'elevenlabs';

export interface AudioInterviewConfig {
  provider: AudioInterviewProvider;
  elevenlabs: {
    agentId: string;
    apiEndpoint: string;
    websocketUrl: string;
  };
}

export const audioInterviewConfig: AudioInterviewConfig = {
  // Toggle between 'livekit' | 'elevenlabs'
  provider: 'elevenlabs',

  // ElevenLabs configuration (EU residency)
  elevenlabs: {
    agentId: process.env.NEXT_PUBLIC_ELEVEN_LABS_INBOUND_AGENT_ID ?? '',
    apiEndpoint: process.env.NEXT_PUBLIC_ELEVEN_LABS_API_ENDPOINT ?? '',
    websocketUrl: process.env.NEXT_PUBLIC_ELEVEN_LABS_WEBSOCKET_URL ?? '',
  },
};
